import { Component, OnDestroy } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { Router, RouterOutlet, RoutesRecognized } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from './shared/services/shared.service';
import { GlobalService } from './shared/services/global.service';
import { environment } from '../environments/environment';
import { HTML2TXTPipe } from './shared/pipe/common.pipe';
import { filter, startWith, pairwise, retry, throwError, timer } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet, MatProgressSpinner],
})
export class AppComponent implements OnDestroy {
    private readonly env: any = environment;
    private readonly urlPath: any;
    public routeParams: any;

    private toRoute: any;
    private toRoute1: any;
    private toRouteParams: any;
    private fromRoute1: any;
    private isSavedAnswer: any;
    private allStats1: any = [];
    private readonly childData: any = ['One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight'];
    private queryParamsOBJ: any = {};
    private eventObj = {};
    private readonly subscribeObj: any;
    private readonly splitUrlPath: any;

    constructor(public sharedService: SharedService,
        private readonly globalService: GlobalService,
        public HTML2TXT: HTML2TXTPipe,
        public translate: TranslateService,
        private readonly router: Router) {
        console.info('App Component Constructor.....');
        translate.addLangs(['ar', 'cs', 'de', 'en', 'es', 'fr', 'it', 'ja', 'nl', 'pl', 'pt', 'ru', 'sv', 'th', 'tr', 'zh']);
        translate.setDefaultLang('en');
        console.info('App Component Loaded.....');

        this.urlPath = globalThis.location.href;
        this.splitUrlPath = (this.urlPath).split('?');

        if (!this.splitUrlPath?.length) {
            console.error(`[AppComponent] access_denied - splitUrlPath is not available in the query string`);
            this.router.navigate(['/access_denied']);
            return;
        }

        if (!!this.splitUrlPath[1] && this.splitUrlPath[1] === 'null') {
            console.error(`[AppComponent] access_denied - splitUrlPath[1] is null in the query string`);
            this.router.navigate(['/access_denied']);
            return;
        }

        this.routeParams = new URLSearchParams(this.splitUrlPath[1]);
        console.info('Route Params.....', this.routeParams);

        if(this.urlPath.includes('consent-page')){
            const objData:any = {};
            if(this.splitUrlPath[1]){
                this.splitUrlPath[1].split('&').forEach((key:any)=>{
                    const data = key.split("=");
                    if(data.length){
                        objData[data[0]] = data[1] || '';
                    }
                });
            }
            this.router.navigate(['/consent-page'], { queryParams: {...objData}});
            return;
        }

        if(this.urlPath.includes('security-check')){
            console.info('Security Check.....', this.splitUrlPath, this.urlPath);
            const objData:any = {};
            this.splitUrlPath[1].split('&').forEach((key:any)=>{
                const data = key.split("=");
                if(data.length){
                    try {
                        objData[data[0]] = decodeURIComponent(data[1] || '');
                    } catch (e) {
                        objData[data[0]] = data[1] || '';
                    }
                }
            });
            if(this.urlPath.includes('security-check-all')){
                this.router.navigate(['/security-check-all'], { queryParams:{...objData}});
                return;
            }
            this.router.navigate(['/security-check'], { queryParams:{...objData}});
            return;
        }

        if(this.urlPath.includes('survey-satisfaction')){
            const objData:any = {};
            this.splitUrlPath[1].split('&').forEach((key:any)=>{
                const data = key.split("=");
                if(data.length){
                    objData[data[0]] = data[1] || '';
                }
            });
            this.router.navigate(['/survey-satisfaction'], { queryParams:{...objData}});
            return;
        }

        if (this.urlPath.includes('access_denied') || globalThis.location.pathname.includes('access_denied')) {
            return;
        }

        if (this.routeParams.get('langCode')) {
            let langCode = this.routeParams.get('langCode').toLowerCase();
            if(langCode && !['ar', 'cs', 'de', 'en', 'es', 'fr', 'it', 'ja', 'nl', 'pl', 'pt', 'ru', 'sv', 'th', 'tr', 'zh'].includes(langCode)){
                langCode = 'en';
            }
            this.translate.use(langCode);
        }

        if (!!this.routeParams.get('survNum') && this.routeParams.get('survNum') === 'null'
            && !!this.routeParams.get('uid') && this.routeParams.get('uid') === 'null') {
            console.error(`[AppComponent] access_denied - survNum and uid are null in the query string`);
            this.router.navigate(['/access_denied']);
            return;
        }

        const objData:any = {};
        if(this.splitUrlPath?.length
            && this.splitUrlPath[1]){
            this.splitUrlPath[1].split('&').forEach((key:any)=>{
                const data = key.split("=");
                if(data.length){
                    objData[data[0]] = data[1] || '';
                }
            });
            this.globalService.getQueryParamsAndSaveToVariable({...objData});
        }

        this.sharedService.rootData = {
            piiQuesFormDetails : {}, //having  pii form details entered by user
            smsQuesFormDetails : {},
            sentAdrsValidOnUSPS : 0, //how much time form will sent on USPS for Address validation
            invalidPIIQusKey : {},
            pcId : this.env.innovate.pointClubSupId,
            piiCatId : this.env.innovate.piiCategoryId,
            dobRHQId : this.env.innovate.dobRedHerringQId,
            bbCenterExpectedDateQue : this.env.innovate.bbCenterExpectedDueDateQueId,
            bbCenterChildInfoQueId : this.env.innovate.bbCenterChildInfoQueId,
            babyCenterProfileSurveyJobId : this.env.innovate.babyCenterProfileSurveyJobId,
            wteProfileSurveyJobId : this.env.innovate.wteProfileSurveyJobId,
            profilingJobs : this.env.innovate.profilingJobs,
            trimsterQuestionsDetails : [],
            trimsterAns : '',
            trimsterWeekAns : '',
            bbCenterChildDetails : [],
            piiQuesKey : [],
            originalTermURL : '',
            isRAIDobZipAdded : this.routeParams.get('RAIJuris'), //Saved in group collection if DOB+Zip file uoloaded.
            showConfirmMesg : false, //If PII form value populated then we will show confirm message to the user
            //@ADMIN-2632 Contain selected either Age or zip code value(depand on ques seq) and used to check these value in RAI_AGE_Zip collection.
            //If Age asked first(vice versa),  when zipcode ask we will check both answer in collection if they matched user will continue else terminate
            selectedDobZipRAI : {},
            isPIIOPTAdded : false,
            babyCenterExpectedDueDate : false,
            isAgeOfChildAdded : false,
            bbCenterChildInfoQueDetails : [],
            isPCProfile : this.routeParams.get('isPCProfile'),
            smsVerified : this.routeParams.get('isMobileVerified'),
            oeQues : this.routeParams.get('oeQuestionIds'),
            taQues : this.routeParams.get('taQuestionIds'),
            geoQuestionsKeyDetails : [],
            zipMasterData : {},
            verifyMobNumSMS : false,
            validToVerifySMS : true,
            smsVerifyCount : 0,
            termReason : '',
            countryCode : (!!this.routeParams.get('cntryCode') && this.routeParams.get('cntryCode') !== 'null')
                            ? this.routeParams.get('cntryCode')
                            : 'US',
            PID : (!!this.routeParams.get('PID') && this.routeParams.get('PID') !== 'null')   // memeber id or PID
                    ? this.routeParams.get('PID')
                    : '',
            supCode : (!!this.routeParams.get('supCode') && this.routeParams.get('supCode') !== 'null')
                        ? this.routeParams.get('supCode')
                        : 'FEsupplier',
            supId : this.routeParams.get('supId'),  // used during pixel trigger
            surveyFlowLogic : true,
        }

        console.info('Shared Service Root Data.....', JSON.stringify(this.sharedService.rootData));

        let uid: any = 'Test';
        if (!!this.routeParams.get('uid') && this.routeParams.get('uid') !== 'null') {
            // actual survey
            uid = this.routeParams.get('uid');
        }
        this.sharedService.rootData.uid = uid;
        const payload:any = {
            encSurveyNumber : this.routeParams.get('survNum'),
            supCode: this.sharedService.rootData.supCode,
            uid
        };
        if (!this.routeParams.get('survNum') || this.routeParams.get('survNum') === 'null') {
            const params = new URLSearchParams(globalThis.location.search);
            console.error(`[AppComponent] access_denied - survNum missing from query string ${JSON.stringify(this.sharedService.rootData)} `);
        }
        if(this.env.app === 'innovateBackendApp-Staging'){
            console.log('getSurveyDetails payload ======> ', JSON.stringify(payload));
        }
        this.sharedService.getSurveyDetails(payload)
            .pipe(
                retry({
                    count: 1,
                    delay: (err: any) => {
                        if (err?.status === 0) {
                            return timer(1000);
                        }
                        return throwError(() => err);
                    }
                })
            )
            .subscribe({

            next: (respObj:any) => {

                if(respObj.status !== 'Success' || !respObj.data){
                    console.error(`[AppComponent] access_denied - getSurveyDetails failed - status not Success or data not available`);
                    this.router.navigate(['/access_denied']);
                    return;
                }
                respObj.data = this.sharedService.commonDecryptionMethod(respObj.data);
                if(!respObj.data.groupDetail){
                    console.error(`[AppComponent] access_denied - getSurveyDetails failed - groupDetail not found`);
                    this.router.navigate(['/access_denied']);
                    return;
                }
                if (respObj.data.decryptedToken) {
                    // decrypted token for only actual survey, for test survey it will be undefined
                    this.sharedService.rootData.token = respObj.data.decryptedToken;
                }
                this.setNewRelicUserIdFromSurveyToken(this.sharedService.rootData.token);
                this.sharedService.rootData.grp_id = Number.parseInt(respObj.data.decryptedSurveyNum);
                this.sharedService.rootData.currentGrpId = this.sharedService.rootData.grp_id;
                this.sharedService.rootData.group = respObj.data.groupDetail;
                this.sharedService.rootData.isPega = respObj.data.groupDetail.isPega;
                this.sharedService.rootData.mid = respObj.data.mid;
                this.sharedService.rootData.jb_id = respObj.data.jobDetail.id;
                this.sharedService.rootData.jobDetailsObj = respObj.data.jobDetail;
                this.sharedService.rootData.supplierDetail = respObj.data.supplierDetail;
                this.sharedService.rootData.roundTableTrackingEnabled = respObj.data.roundTableTrackingEnabled;
                this.sharedService.rootData.compFingerPrint = respObj.data.digitalFingerprinting;
                this.sharedService.rootData.oeThreshLev = respObj.data?.taLevel || respObj.data?.jobDetail?.oeThreshLev;

                this.sharedService.rootData.isOEValidation = !respObj.data.jobDetail.chkOeValid
                                                                ? 0
                                                                : ((respObj.data?.dsblTA)
                                                                    ? 0
                                                                    : 1);

                // group language
                this.sharedService.rootData.langCode = (!!this.routeParams.get('langCode') && this.routeParams.get('langCode') !== 'null')
                ? this.routeParams.get('langCode')
                : '';

                // keyForSaving groups PID / group / supplier for saved answers
                this.sharedService.rootData.keyForSaving = this.sharedService.rootData.grp_id + '_' + this.sharedService.rootData.supCode + '_' + this.sharedService.rootData.PID;

                //For pc case AGE question never asked and get calculated value to check DOB
                if (!!this.routeParams.get('AGE') && !Number.isNaN(Number.parseInt(this.routeParams.get('AGE') ?? '', 10))) {
                    this.sharedService.rootData.trgAgeQuesAns = this.routeParams.get('AGE');
                    //In case of pointclub ZIPCODES question asked(Not expired) and Age_jurisdiction file uploaded
                    //At that time we will matched both question with that file
                    this.sharedService.rootData.selectedDobZipRAI["age"] = this.routeParams.get('AGE');
                }

                // this.routeParams.get('Test')
                this.sharedService.rootData.Test = respObj.data.isDecryptedTokenTest;
                if (this.sharedService.rootData.Test) {
                    // for test survey adding Test in the end of key so actual and test survey will be different
                    this.sharedService.rootData.keyForSaving += '_Test';
                }

                // this.routeParams.get('existIds'] - are those id's which already gone through from survey using querystring
                if (!!this.routeParams.get('existIds') && this.routeParams.get('existIds') !== 'null') {
                    payload['existIds'] = this.routeParams.get('existIds');
                }
                if(this.sharedService.rootData.smsVerified){
                    payload['isMobVerified'] = this.sharedService.rootData.smsVerified
                }
                if(this.routeParams.get('oeQuestionIds')){
                    payload['oeQuestionIds'] = this.routeParams.get('oeQuestionIds')
                }

                if(this.routeParams.get('taQuestionIds')){
                    payload['taQuestionIds'] = this.routeParams.get('taQuestionIds')
                }               

                this.sharedService.getSurveyTargetDetails(payload)
                    .pipe(
                        retry({
                            count: 1,
                            delay: (err: any) => {
                                if (err?.status === 0) {
                                    console.info('[AppComponent] getSurveyTargetDetails retry delay '+ JSON.stringify(err));
                                    return timer(1000);
                                }
                                return throwError(() => err);
                            }
                        })
                    )
                    .subscribe({

                    next: (respDetails: any) => {

                        respDetails.data = this.sharedService.commonDecryptionMethod(respDetails.data);
                        this.sharedService.rootData.grpTrgtQuestions = respDetails.data['grpTrgtQuestions'];
                        this.sharedService.rootData.ZipTrgQues = respDetails.data['ZipTrgQues'];

                        this.sharedService.rootData.redirectToGroup = respDetails.data['redirectToGroup'] || null;
                        this.sharedService.rootData.piiQuesKey = respDetails.data['piiQuesKey'];
                        this.sharedService.rootData.isPIIOPTAdded = respDetails.data['isPIIOPTAdded'];

                        this.sharedService.rootData.questions = respDetails.data['questions'];
                        this.sharedService.rootData.babyCenterExpectedDueDate = respDetails.data['babyCenterExpectedDueDate'];
                        this.sharedService.rootData.trimsterQuestionsDetails = respDetails.data['trimsterQuestionsDetails'];
                        this.sharedService.rootData.geoQuestionsKeyDetails = respDetails.data['geoQuestionsKeyDetails'];
                        this.sharedService.rootData.targets = respDetails.data['grpTargets'];
                        if(this.sharedService.rootData.questions?.length){
                            const urlPath = this.splitUrlPath[0].split('/');
                            const ind = this.sharedService.rootData.questions.findIndex((que:any)=> que.questionKey.toLowerCase() === urlPath.at(-1)?.toLowerCase());

                            //If we are on last question no need to change index of question
                            if(ind !== -1){
                                const frstVal = JSON.parse(JSON.stringify(this.sharedService.rootData.questions[ind]));
                                this.sharedService.rootData.questions.splice(ind,1);
                                this.sharedService.rootData.questions.unshift(frstVal);
                            }
                        }
                        this.sharedService.updateRootDataQuestions(this.sharedService.rootData.questions);

                        if (Object.keys(this.eventObj).length) {
                            this.checkRouter(this.eventObj);
                        }

                        if (!respDetails.data['questions'] || !Object.keys(respDetails.data['questions']).length) {
                            this.sharedService.rootData.viewLoading = false;
                            const urlPath = this.splitUrlPath[0].split('/');
                            if (urlPath.at(-1) !== 'final') {
                                this.router.navigate(['/survey/final'], { queryParams: this.routeParams });
                            }
                        }
                    },
                    error: (err: any) => {
                        console.error(`getSurveyTargetDetails error access_denied ======> ${JSON.stringify(err)} ${JSON.stringify(this.sharedService.rootData)} ${JSON.stringify(payload)}`);
                        this.router.navigate(['/access_denied']);
                        return;
                    }
                    });
            },
            error: (err: any) => {
                console.error(`getSurveyDetails error access_denied =======> ${JSON.stringify(err)} ${JSON.stringify(this.sharedService.rootData)}`);
                this.router.navigate(['/access_denied']);
                return;
            }
            });

        this.subscribeObj = this.router.events
            .pipe(filter((evt: any) => evt instanceof RoutesRecognized), startWith(null), pairwise())
            .subscribe((events: [RoutesRecognized | null, RoutesRecognized | null]) => {
                this.eventObj = events;
                this.sharedService.rootData.viewLoading = true;
                //##### Set Timeout Because Below(Router Change) Functionality Execute before Above Function (Amarish)
                if ((this.sharedService.rootData.token && !this.sharedService.rootData.Test) || this.sharedService.rootData.Test) {
                    this.checkRouter(events);
                }
                // }, 2000);
            })
    }

    ngOnDestroy(): void {
        this.subscribeObj.unsubscribe();
    }

    /** Correlates Browser sessions/errors with this respondent when the NR agent is loaded. */
    private setNewRelicUserIdFromSurveyToken(token: string | undefined): void {
        if (!token) {
            return;
        }
        (window as any).newrelic?.setUserId?.(token);
    }

    switchLang(lang: string) {
    }

    private checkRouter(events: any) {
        // setTimeout(() => {

        const previousUrlOBJ = events[0];
        const currentUrlOBJ = events[1];

        this.toRouteParams = currentUrlOBJ.state.root.children?.length
            ? currentUrlOBJ.state.root.children[0].params['questionType']
            : '';

        const splitUrlPathPrevious = previousUrlOBJ ? (previousUrlOBJ.url).split('?') : [];
        if (splitUrlPathPrevious?.length) {
            if (splitUrlPathPrevious[0]?.length) {
                let subSplitUrlPathPrevious: any = splitUrlPathPrevious[0].split('/');
                this.fromRoute1 = (!!subSplitUrlPathPrevious[2] && subSplitUrlPathPrevious[2] !== 'null')
                    ? subSplitUrlPathPrevious[2]
                    : null;
            }
        }

        const splitUrlPathCurrent = (currentUrlOBJ.url).split('?');
        if (splitUrlPathCurrent?.length) {
            if (splitUrlPathCurrent[0]?.length) {
                let subSplitUrlPathCurrent: any = splitUrlPathCurrent[0].split('/');
                this.toRoute = !!subSplitUrlPathCurrent[1] && subSplitUrlPathCurrent[1] !== 'null'
                    ? subSplitUrlPathCurrent[1]
                    : null;
                this.toRoute1 = (!!subSplitUrlPathCurrent[2] && subSplitUrlPathCurrent[2] !== 'null')
                    ? subSplitUrlPathCurrent[2]
                    : null;
            }
        }

        this.queryParamsOBJ = currentUrlOBJ.state.root.queryParams;

        let currentState: any;

        if (this.toRoute1 === 'final'
            || this.toRoute1 === 'closed'
            || this.toRoute1 === 'pii'
            || this.toRoute1 === 'sms_verification') {
            currentState = this.toRoute1;
        } else {
            // age // #1039 - dash key in question Key
            currentState = !!this.toRouteParams && this.toRouteParams != 'null'
                ? this.HTML2TXT.transform((this.toRouteParams).toLowerCase())
                : '';
        }

        //show current state form , currentState is form-id in surveyProcess.html
        this.sharedService.rootData.currentState = currentState;

        if ((this.toRoute === null || !this.toRoute.includes('survey')) && this.toRoute !== 'access_denied') {
            console.error(`[AppComponent] access_denied - toRoute is not available in the query string`);
            this.router.navigate(['/access_denied']);
        } else if (this.toRoute === 'access_denied' || (this.toRoute === 'survey' && this.toRoute1 === 'closed')) {
            this.sharedService.rootData.viewLoading = false;
        } else {
            const localStorageSavedAnswers: any = this.sharedService.getLocalStorage('localStorageSavedAnswers');
            //Check in localStorage all questions answer is saved or not
            this.isSavedAnswer = (localStorageSavedAnswers?.length
                && localStorageSavedAnswers[0][this.sharedService.rootData.keyForSaving])
                ? localStorageSavedAnswers[0][this.sharedService.rootData.keyForSaving]
                : null;

            const fromState = (this.fromRoute1) ? this.fromRoute1.toUpperCase() : '';

            //setTimeout(() => {

            if (this.sharedService.rootData.token && !this.sharedService.rootData.Test) {
                this.sharedService.getTransaction(this.sharedService.rootData.uid)
                    .pipe(
                        retry({
                            count: 1,
                            delay: (err: any) => {
                                if (err?.status === 0) {
                                    return timer(1000);
                                }
                                return throwError(() => err);
                            }
                        })
                    )
                    .subscribe({
                        next: (trans: any) => {
                            trans.data = this.sharedService.commonDecryptionMethod(trans.data);
                            if (!!trans && trans != 'null' && trans.data) {
                                this.sharedService.rootData.mbr_id = trans.data.mbr_id; // get PID from database
                                this.sharedService.rootData.jb_id = trans.data.jb_id; // get job id form db
                                this.sharedService.rootData.isDashboard = trans.data.isDashboard; // get isDashboard
                                this.sharedService.rootData.originalTermTrans = trans.data.st;
                                this.sharedService.rootData.originalTerm = trans.data.st == environment.innovate.transactionStatus['PST'] || trans.data.st == environment.innovate.transactionStatus['PSQT'] || trans.data.st == environment.innovate.transactionStatus['PSOQ'];
                                const fingerPrint = this.sharedService.rootData.compFingerPrint || this.sharedService.rootData.jobDetailsObj.dgtl_fngr_prnt;
                                this.sharedService.rootData.isRDResponseSaved = !!(this.env.innovate.digitalFingerPrint['Research Defender'] === fingerPrint 
                                                                              && trans?.data?.smplChnResp 
                                                                              && Object.keys(trans.data.smplChnResp).length);
                                this.sharedService.rootData.isCleanIdResponseSaved = !!(this.env.innovate.digitalFingerPrint['Clean ID'] === fingerPrint 
                                                                                   && trans?.data?.opinonRouteResp 
                                                                                   && Object.keys(trans.data.opinonRouteResp).length);
                                this.sharedService.rootData.isVerisoulResponseSaved = !!(this.env.innovate.digitalFingerPrint['Verisoul'] === fingerPrint 
                                                                                    && trans?.data?.veriSoulResp 
                                                                                    && Object.keys(trans?.data?.veriSoulResp).length);
                                if (this.sharedService.rootData.originalTerm && !this.sharedService.rootData.originalTermURL) {
                                    this.sharedService.getSupplierRedirectURL(this.sharedService.rootData.uid)
                                        .subscribe({
                                            next: (data: any) => {
                                                this.sharedService.rootData.originalTermURL = this.env.innovate.oldRouteEnable
                                                    ? data.url
                                                    : data.data;
                                            },
                                            error: (err: any) => {
                                                console.error(`[AppComponent] getSupplierRedirectURL error:${JSON.stringify(err)} ${JSON.stringify(this.sharedService.rootData)}`);
                                            }
                                        });
                                }

                                if (trans.data.hasOwnProperty("RIDResp"))
                                    this.sharedService.rootData.RVID = trans.data.RIDResp.RVid;

                                // now we are checking that PID and supCode of query string AND db, if not than access denied
                                // FESupCode match in case of include/exclude csv supcode survey
                                if ((this.sharedService.rootData.PID?.toString() == this.sharedService.rootData.mbr_id?.toString()) &&
                                    (trans.data.supCode?.toString() == this.sharedService.rootData.supCode?.toString()) ||
                                    (trans.data.FESupCode?.toString() == this.sharedService.rootData.supCode?.toString())) {

                                    let isCmplt = trans.data.isCmp;
                                    if (!this.sharedService.rootData.surveyFlowLogic && isCmplt) {
                                        this.router.navigate(['/survey/closed'], { queryParams: { message: 2, ...this.queryParamsOBJ } });

                                    } else {
                                        // it is the case of accessible stat
                                        // localStorageService.clearAll();
                                        this.sharedService.rootData.demographic = {}; // this is used for sungle punch, numeric and text field in form model
                                        this.sharedService.rootData.multipunch = {}; // this is used for multipunch in form model
                                        this.sharedService.doMultiPunchCheckbox(this.sharedService.rootData.multipunch);
                                        let piiQuesFormDetails, smsQuesFormDetails;

                                        let stateName = (!!currentState && currentState != 'null')
                                            ? currentState.toUpperCase()
                                            : null;  // current state name

                                        if (currentState && currentState.toLowerCase() == "final") {
                                            let isAllAnswerSaved = true;
                                            /**
                                             * If user hasn't give any questions answer of group targeting and see the final page then we will mark as PSQT
                                             *
                                             * 1) We will check answer is stored in the localstorageSavedAnswer or not
                                             * 2) If answer is stored in the localstorage then we will check that all question answer is available or not as per the group targetting
                                             * 3) If answer is not stored in the localstorage then we will check the group targetting is available or not.
                                             * 4) If we found any group targetting is not answered then we will mark as PSQT.
                                             */

                                            //check the piiQuesForm and smsQuesForm details are added or not
                                            piiQuesFormDetails = (this.sharedService.rootData.piiQuesFormDetails && Object.keys(this.sharedService.rootData.piiQuesFormDetails).length)
                                                ? Object.keys(this.sharedService.rootData.piiQuesFormDetails)
                                                : [];

                                            smsQuesFormDetails = (this.sharedService.rootData.smsQuesFormDetails && Object.keys(this.sharedService.rootData.smsQuesFormDetails).length)
                                                ? Object.keys(this.sharedService.rootData.smsQuesFormDetails)
                                                : [];

                                            let termSurveyAns: any = [];

                                            if (this.isSavedAnswer) {
                                                // check user has gave all the questions which are in group targeting
                                                let isSavedAnswerKeys = this.isSavedAnswer.map((queAns: any) => { return Object.keys(queAns) }).flat(1); // fetch question keys
                                                let isPIIquestFilled = this.isSavedAnswer.find((ans: any) => {
                                                    return ans.piiFormDetails
                                                });
                                                let isSMSquestFilled = this.isSavedAnswer.find((ans: any) => {
                                                    return ans.smsFormDetails
                                                })

                                                if (isSavedAnswerKeys?.length &&
                                                    this.sharedService.rootData.questions?.length) {
                                                    if (this.sharedService.rootData.jb_id == this.sharedService.rootData.babyCenterProfileSurveyJobId ||
                                                        this.sharedService.rootData.jb_id == this.sharedService.rootData.wteProfileSurveyJobId) {

                                                        isSavedAnswerKeys.forEach((key: string) => {
                                                            if (this.env.innovate.skipQuestionsOn[key]) {
                                                                let svAns = this.isSavedAnswer.find((ans: any) => {
                                                                    return ans[key] && ans[key].question_type == "Single Punch"
                                                                });
                                                                if (svAns && (!this.env.innovate.skipQuestionsOn[key].skipOnValue ||
                                                                    this.env.innovate.skipQuestionsOn[key].skipOnValue == svAns[key].option_text.toLowerCase())) {
                                                                    this.sharedService.rootData.questions = this.sharedService.rootData.questions
                                                                        .filter((que: any) => {
                                                                            return !this.env.innovate.skipQuestionsOn[key].skipKeys.includes(que.questionKey)
                                                                        });
                                                                }
                                                            }
                                                        });
                                                    }

                                                    let questionKeys = this.sharedService.rootData.questions.map((que: any) => {
                                                        return que.questionKey
                                                    }); // question key of group targetting;

                                                    const isZipcodeAvailable = questionKeys.indexOf("ZIPCODES");
                                                    if (isZipcodeAvailable !== -1) {
                                                        questionKeys.splice(isZipcodeAvailable, 1);
                                                        questionKeys = questionKeys.concat(this.sharedService.rootData.geoQuestionsKeyDetails);
                                                    }

                                                    //if we add ADDRESS_LINE in group targeting then we will remove it from the PII question and then add address detail questions
                                                    let indexOfAddress = questionKeys.indexOf("ADDRESS_LINE");
                                                    if (indexOfAddress > -1) {
                                                        questionKeys.splice(indexOfAddress, 1);
                                                        questionKeys.concat(['street1', 'city', 'state', 'zip']);
                                                    }

                                                    for (let qKey in questionKeys) {
                                                        if (!isSavedAnswerKeys.includes(questionKeys[qKey])) {
                                                            if (((!piiQuesFormDetails?.length
                                                                || !piiQuesFormDetails.includes(questionKeys[qKey])))
                                                                && !isPIIquestFilled
                                                                && !isSMSquestFilled
                                                                && !this.sharedService.rootData.zipMasterData[questionKeys[qKey]]) {
                                                                isAllAnswerSaved = false;
                                                                break;
                                                            }
                                                        }
                                                        if (this.sharedService.rootData.surveyFlowLogic) {
                                                            let qky = questionKeys[qKey];
                                                            this.isSavedAnswer
                                                                .filter((ans: any) => {
                                                                    if (ans[qky]?.terminate) {
                                                                        termSurveyAns.push(ans[qky]);
                                                                    };
                                                                });
                                                        }
                                                    }
                                                }
                                            }
                                            if (!this.isSavedAnswer && this.sharedService.rootData.questions?.length) {
                                                isAllAnswerSaved = false;
                                            }

                                            if (!isAllAnswerSaved || termSurveyAns.length) {
                                                let body: any = {};
                                                body.transStatus = environment.innovate.transactionStatus['PSQT']; //termination
                                                body.uid = this.sharedService.rootData.uid;
                                                body.reason = "URL Manipulation";
                                                body.jobId = this.sharedService.rootData.jb_id;
                                                body.supCode = this.sharedService.rootData.supCode;
                                                body.grpId = this.sharedService.rootData.grp_id;
                                                body.PID = this.sharedService.rootData.PID;
                                                body.isAllAnswerSaved = isAllAnswerSaved;
                                                body.termSurveyAnsLength = termSurveyAns.length

                                                this.sharedService.preSurveyTerminationInQA(body)
                                                    .subscribe({
                                                        next: (data: any) => {
                                                            this.sharedService.rootData.viewLoading = false;
                                                            this.router.navigate(['/survey/closed'], { queryParams: { message: 1, ...this.queryParamsOBJ } });
                                                            if (data.data?.surveyUrl) {
                                                                this.sharedService.getPersonilzedSurvey(this.sharedService.rootData.uid).subscribe({
                                                                    next: (resp: any) => {
                                                                        if (resp?.data?.url) {
                                                                            data.data.surveyUrl = resp.data.url;
                                                                        }
                                                                        setTimeout(() => {
                                                                            globalThis.location.href = data.data.surveyUrl;
                                                                        }, 2000);
                                                                    },
                                                                    error: (_err: any) => {
                                                                        setTimeout(() => {
                                                                            globalThis.location.href = data.data.surveyUrl;
                                                                        }, 2000);
                                                                    }
                                                                });
                                                            }
                                                        },
                                                        error: (_err) => {
                                                            this.router.navigate(['/survey/closed'], { queryParams: this.queryParamsOBJ });
                                                        }
                                                    });
                                            }
                                            this.sharedService.rootData.viewLoading = false;
                                        }
                                        else {
                                            const isTerm = this.sharedService.commonPCCondition();
                                            if (isTerm && this.sharedService.rootData.originalTerm) {
                                                this.sharedService.rootData.viewLoading = false;
                                                this.router.navigate(['/survey/closed'], { queryParams: { message: 1, ...this.queryParamsOBJ } });
                                                this.sharedService.getPersonilzedSurvey(this.sharedService.rootData.uid).subscribe({
                                                    next: (resp: any) => {
                                                        if (resp?.data?.url) {
                                                            this.sharedService.rootData.originalTermURL = resp.data.url;
                                                        }
                                                        if (this.sharedService.rootData.originalTermURL) {
                                                            setTimeout(() => {
                                                                globalThis.location.href = this.sharedService.rootData.originalTermURL
                                                            }, 2000);
                                                        } else {
                                                            this.sharedService.getSupplierRedirectURL(this.sharedService.rootData.uid)
                                                                .subscribe({
                                                                    next: (data: any) => {
                                                                        this.sharedService.rootData.originalTermURL = this.env.innovate.oldRouteEnable
                                                                            ? data.url
                                                                            : data.data;
                                                                        setTimeout(() => {
                                                                            globalThis.location.href = this.sharedService.rootData.originalTermURL;
                                                                        }, 2000);
                                                                    },
                                                                    error: (err: any) => {
                                                                        console.error(`[AppComponent] getSupplierRedirectURL (term) error:${JSON.stringify(err)} ${JSON.stringify(this.sharedService.rootData)}`);
                                                                    }
                                                                });
                                                        }
                                                    },
                                                    error: (err: any) => {
                                                        console.error(`[AppComponent] getPersonilzedSurvey (term) error = :${JSON.stringify(err)} ${JSON.stringify(this.sharedService.rootData)}`);
                                                    }
                                                });
                                            }
                                            else {
                                                if (!(localStorageSavedAnswers?.length)) {
                                                    this.sharedService.rootData.viewLoading = false;
                                                    return;
                                                }

                                                let counter = 0;
                                                localStorageSavedAnswers.forEach((data: any) => {
                                                    if (data[this.sharedService.rootData.keyForSaving]) {
                                                        this.allStats1 = (this.sharedService.rootData.questions?.length)
                                                            ? this.sharedService.rootData.questions.map((que: any) => { return que.questionKey })
                                                            : []; // question key of group targetting;

                                                        (data[this.sharedService.rootData.keyForSaving]).forEach((savedQuestion: any) => {
                                                            if (savedQuestion[stateName]) {
                                                                if (savedQuestion[stateName].question_type != undefined && savedQuestion[stateName].question_type != 'Multipunch') {
                                                                    //qustion is checked or value shown in form, if user already gone throug from same question
                                                                    this.sharedService.rootData.demographic.selected_opt = savedQuestion[stateName].answer;
                                                                } else {
                                                                    let selectedOptions: any = {};
                                                                    this.sharedService.rootData.selectedCheckboxes = 0;
                                                                    savedQuestion[stateName].answer
                                                                        .split(',').forEach((optionId: any) => {
                                                                            let intOpt = Number.parseInt(optionId);
                                                                            selectedOptions[intOpt] = true;
                                                                            this.sharedService.rootData.selectedCheckboxes++;
                                                                        });
                                                                    this.sharedService.rootData.multipunch = selectedOptions;
                                                                    this.sharedService.doMultiPunchCheckbox(this.sharedService.rootData.multipunch);
                                                                }
                                                            }

                                                            let questionKeys = (this.sharedService.rootData.questions?.length)
                                                                ? this.sharedService.rootData.questions.map((que: any) => { return que.questionKey })
                                                                : []; // question key of group targetting;

                                                            if (fromState && savedQuestion[fromState] &&
                                                                questionKeys.length &&
                                                                this.env.innovate.skipQuestionsOn[fromState]) {
                                                                let answer = savedQuestion[fromState];
                                                                if (!this.env.innovate.skipQuestionsOn[fromState].skipOnValue ||
                                                                    this.env.innovate.skipQuestionsOn[fromState].skipOnValue ==
                                                                    answer.option_text.toLowerCase()) {
                                                                    this.sharedService.rootData.questions = this.sharedService.rootData.questions
                                                                        .filter((que: any) => {
                                                                            return !this.env.innovate.skipQuestionsOn[fromState].skipKeys.includes(que.questionKey)
                                                                        });

                                                                    this.allStats1 = (this.sharedService.rootData.questions?.length)
                                                                        ? this.sharedService.rootData.questions.map((que: any) => { return que.questionKey })
                                                                        : []; // question key of group targetting;
                                                                }
                                                                if (this.env.innovate.skipQuestionsOn[fromState].addChildInfo
                                                                    && this.env.innovate.skipQuestionsOn[fromState].skipOnValue
                                                                    && this.env.innovate.skipQuestionsOn[fromState].skipOnValue !== answer.option_text.toLowerCase()
                                                                    && !this.sharedService.rootData.bbCenterChildDetails.length) {
                                                                    let count = Number.parseInt(answer.option_text);
                                                                    this.sharedService.rootData.bbCenterChildDetails = [];
                                                                    for (let i = 0; i < count; i++) {
                                                                        this.sharedService.rootData.bbCenterChildDetails.push({
                                                                            'name': 'Child ' + this.childData[i],
                                                                            'month': '',
                                                                            'year': '',
                                                                            'dob': '',
                                                                            'gender': '',
                                                                            'age': ''
                                                                        });
                                                                    }
                                                                }
                                                            } else {
                                                                for (let svQue in savedQuestion) {
                                                                    if (this.env.innovate.skipQuestionsOn[svQue] && savedQuestion[svQue] && savedQuestion[svQue].question_type == 'Single Punch') {
                                                                        if (!this.env.innovate.skipQuestionsOn[svQue].skipOnValue
                                                                            || this.env.innovate.skipQuestionsOn[svQue].skipOnValue ==
                                                                            savedQuestion[svQue].option_text.toLowerCase()) {

                                                                            this.sharedService.rootData.questions = this.sharedService.rootData.questions
                                                                                .filter((que: any) => {
                                                                                    return !this.env.innovate.skipQuestionsOn[svQue].skipKeys.includes(que.questionKey)
                                                                                });

                                                                            this.allStats1 = (this.sharedService.rootData.questions?.length)
                                                                                ? this.sharedService.rootData.questions.map((que: any) => { return que.questionKey })
                                                                                : []; // question key of group targetting;
                                                                        }

                                                                        if (this.env.innovate.skipQuestionsOn[svQue].addChildInfo
                                                                            && this.env.innovate.skipQuestionsOn[svQue].skipOnValue
                                                                            && this.env.innovate.skipQuestionsOn[svQue].skipOnValue !== savedQuestion[svQue].option_text.toLowerCase()
                                                                            && !this.sharedService.rootData.bbCenterChildDetails.length) {
                                                                            let count = Number.parseInt(savedQuestion[svQue].option_text);
                                                                            this.sharedService.rootData.bbCenterChildDetails = [];
                                                                            for (let i = 0; i < count; i++) {
                                                                                this.sharedService.rootData.bbCenterChildDetails.push({
                                                                                    'name': 'Child ' + this.childData[i],
                                                                                    'month': '',
                                                                                    'year': '',
                                                                                    'dob': '',
                                                                                    'gender': '',
                                                                                    'age': ''
                                                                                });
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        });
                                                        let savedAnswers = (localStorageSavedAnswers?.length && localStorageSavedAnswers[0][this.sharedService.rootData.keyForSaving])
                                                            ? localStorageSavedAnswers[0][this.sharedService.rootData.keyForSaving]
                                                            : [];
                                                        let isSavedAnswerKeys = savedAnswers.map((queAns: any) => { return Object.keys(queAns) }).flat(1); // fetch question keys
                                                        let isPIIOptSaved = false;
                                                        piiQuesFormDetails = (this.sharedService.rootData.piiQuesFormDetails
                                                            && Object.keys(this.sharedService.rootData.piiQuesFormDetails).length)
                                                            ? Object.keys(this.sharedService.rootData.piiQuesFormDetails)
                                                            : [];

                                                        for (let t_stat in isSavedAnswerKeys) {
                                                            let index = this.allStats1.indexOf(isSavedAnswerKeys[t_stat]);
                                                            if (index > -1) {
                                                                if (isSavedAnswerKeys[t_stat].toLowerCase() == 'pii_opt') {
                                                                    isPIIOptSaved = true;
                                                                }
                                                                this.allStats1.splice(index, 1);
                                                            }
                                                        }

                                                        if (piiQuesFormDetails.length) {
                                                            let indexOfAddress = this.allStats1.indexOf("ADDRESS_LINE");
                                                            if (indexOfAddress > -1) {
                                                                this.allStats1.splice(indexOfAddress, 1);
                                                                this.allStats1.concat(['street1', 'city', 'state', 'zip']);
                                                            }
                                                        }

                                                        const piiQuesFormArr = [...piiQuesFormDetails];
                                                        for (let i = 0; i < piiQuesFormArr.length; i++) {
                                                            let index = this.allStats1.indexOf(piiQuesFormArr[i]);
                                                            if (index > -1) {
                                                                this.allStats1 = this.allStats1.filter((key: any) => key !== piiQuesFormArr[i]);
                                                                piiQuesFormDetails = piiQuesFormDetails.filter((qKey: any) => qKey !== piiQuesFormArr[i]);
                                                            }
                                                        };

                                                        if (this.allStats1?.length) {
                                                            let setQkey = this.allStats1[0];
                                                            if (this.sharedService.rootData.piiQuesKey?.includes(setQkey)) {
                                                                setQkey = isPIIOptSaved ? 'pii' : 'pii_opt';
                                                            }
                                                            let nextStat = this.HTML2TXT.transform((setQkey).toLowerCase());
                                                            this.router.navigate(['/survey', nextStat], { queryParams: this.queryParamsOBJ });
                                                        } else {
                                                            const piiQuesKeyExists = !!(this.sharedService.rootData.piiQuesKey?.length);
                                                            const piiQuesFormDetailsExists = !!this.sharedService.rootData?.piiFormSubmited;

                                                            piiQuesKeyExists
                                                                ? (piiQuesFormDetailsExists
                                                                    ? this.router.navigate(['/survey/final'], { queryParams: this.queryParamsOBJ })
                                                                    : this.router.navigate(['/survey/pii'], { queryParams: this.queryParamsOBJ }))
                                                                : this.router.navigate(['/survey/final'], { queryParams: this.queryParamsOBJ });
                                                        }
                                                    }
                                                    counter++;
                                                    if (counter === localStorageSavedAnswers.length) {
                                                        this.sharedService.rootData.viewLoading = false;
                                                    }
                                                });
                                            }
                                        }
                                    }
                                } else {
                                    this.router.navigate(['/survey/closed'], { queryParams: { message: 3, ...this.queryParamsOBJ } });
                                }
                            }
                        },
                        error: (err: any) => {
                            console.error(`[AppComponent] getTransaction error access_denied  ${JSON.stringify(err)} ${this.urlPath} ${JSON.stringify(this.sharedService.rootData)}`);
                            this.router.navigate(['/access_denied']);
                        }
                    });
            } else if (this.sharedService.rootData.Test) {
                if (this.sharedService.rootData.originalTerm &&
                    (this.sharedService.rootData.isPCProfile ||
                        (currentState.toLowerCase() === 'final' &&
                            this.sharedService.rootData.surveyFlowLogic)
                    )) {
                    let query_strings = this.sharedService.serialize(this.queryParamsOBJ);
                    this.sharedService.getSupplierTestUrl(query_strings)
                        .subscribe({
                            next: (data: any) => {
                                data.data = this.sharedService.commonDecryptionMethod(data.data);
                                if (this.env.innovate.triggerNewSupplierURL) {
                                    data = data.data;
                                }
                                this.router.navigate(['/survey/closed'], { queryParams: this.queryParamsOBJ });
                                setTimeout(() => {
                                    if (data?.supplierTestUrl)
                                        globalThis.location.href = data.supplierTestUrl;
                                }, 2000);
                            },
                            error: (err: any) => {
                                console.error(`getSupplierTestUrl error ======> ${JSON.stringify(err)}`);
                                this.router.navigate(['/survey/closed'], { queryParams: this.queryParamsOBJ });
                            }
                        });
                } else {
                    this.sharedService.rootData.viewLoading = false;
                    this.sharedService.rootData.demographic = {}; // this is used for sungle punch, numeric and text field in form model
                    this.sharedService.rootData.multipunch = {}; // this is used for multipunch in form model
                    if (this.isSavedAnswer
                        && fromState === this.env.innovate.babyCenterChildCountQueKey) {
                        // fetch question keys
                        const isSavedAnswerKeys = this.isSavedAnswer
                            .map((queAns: any) => Object.keys(queAns)).flat(1);

                        const childCountData = isSavedAnswerKeys.indexOf(fromState);

                        if (childCountData !== -1) {
                            let count = Number.parseInt(this.isSavedAnswer[childCountData][fromState].option_text);
                            this.sharedService.rootData.bbCenterChildDetails = [];
                            for (let i = 0; i < count; i++) {
                                this.sharedService.rootData.bbCenterChildDetails.push({
                                    'name': 'Child ' + this.childData[i],
                                    'month': '',
                                    'year': '',
                                    'dob': '',
                                    'gender': '',
                                    'age': ''
                                });
                            }
                        }
                    }
                }
            } else {
                this.router.navigate(['/survey/closed'], { queryParams: { message: 4, ...this.queryParamsOBJ } });
            }
        }
    }
}